import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { ButtonModule } from "@app/shared/button/button.module";
import { UtilsModule } from "@app/shared/utils/utils-module";
import { DistributionPolicyMorAnnex4Component } from "./distribution-policy-mor-annex-4.component";
import { DistributionPolicySignatureModule } from "../distribution-policy-signature/distribution-policy-signature.module";

@NgModule({
    declarations: [DistributionPolicyMorAnnex4Component],
    imports: [CommonModule, ButtonModule, UtilsModule, DistributionPolicySignatureModule],
    exports: [DistributionPolicyMorAnnex4Component],
    providers: [],
})
export class DistributionPolicyMorAnnex4Module {}
